
export class GeoCoordinate {
    latitude: number;
    longitude: number;
}
